import { Divider, Input, Typography } from 'antd';
import React, { useMemo } from 'react';
import { sanitizeHtmlContent } from 'utils/sanitizeHtml';
import ActionParameterForm from './ActionParameterForm';

function EmailAction({ action, onFormsChange, disabled = false }) {
  const html = useMemo(() => sanitizeHtmlContent(action.action_body.html_body), [action.action_body.html_body]);
  return (
    <div className="border border-gray-300 rounded">
      <div style={{ borderBottom: '1px solid' }} className="p-3 bg-[#F1F2F3]  border-gray-300">
        <div className="flex items-center whitespace-nowrap">
          <div className="bg-gray-100 px-3 py-2 border border-r-0 border-gray-300 rounded-l text-gray-600 font-medium">
            Subject
          </div>
          <div className="flex-1 px-3 py-2 border border-gray-300 rounded-r bg-[#F1F2F3] text-gray-800 overflow-hidden text-ellipsis">
            {action.action_body.subject}
          </div>
        </div>
      </div>
      {action.action_body && action.action_body.html_body && (
        <Typography.Paragraph className="mb-4 p-3">
          <span dangerouslySetInnerHTML={{ __html: html }} />
        </Typography.Paragraph>
      )}
      <Divider className="my-0" fullWidth />
      {action.definition && action.definition.length > 0 && (
        <div className="bg-[#F1F2F3]">
          <ActionParameterForm
            action={action}
            onFormsChange={onFormsChange}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
}

export default EmailAction;
